import { http } from './config'

export default {

  getRanking: (locality_id, role_id) => {
    return http.get(`indicators/ranking?locality_id=${locality_id}&role_id=${role_id}`)
  },

  exportRankingReport: (locality_id, role_id) => {
    return http.get(`indicators/export_ranking_report?locality_id=${locality_id}&role_id=${role_id}`)
  },

}
